import React from 'react'
import { NotificationRowProps } from './rows/notification-row-shell'
import FriendTookActionRow from './rows/friend-took-action-row'
import GenericNotificationRow from './rows/generic-notification-row'
import NewActionInYourAreaRow from './rows/new-action-in-your-area-row'
import NewActionMatchingInterestsRow from './rows/new-action-matching-interests-row'
import UserFollowedYouRow from './rows/user-followed-you-row'

export type { NotificationRowProps } from './rows/notification-row-shell'

const NotificationRow = (props: NotificationRowProps) => {
  switch (props.notification.type) {
    case 'user_followed_you':
    case 'user_followed':
      return <UserFollowedYouRow {...props} />
    case 'friend_took_action':
      return <FriendTookActionRow {...props} />
    case 'new_action_matching_interests':
      return <NewActionMatchingInterestsRow {...props} />
    case 'new_action_in_your_area':
      return <NewActionInYourAreaRow {...props} />
    default:
      return <GenericNotificationRow {...props} />
  }
}

export default NotificationRow
